export default {

    // 縣市
    counties: [
        'Taipei City', 'Keelung City', 'New Taipei City', 'Yilan County', 'Taoyuan City', 'Hsinchu City', 'Hsinchu County', 'Miaoli County',
        'Taichung City', 'Changhua County', 'Nantou County', 'Chiayi City', 'Chiayi County', 'Yunlin County', 'Tainan City', 'Kaohsiung City',
        'Penghu County', 'Kinmen County', 'Pingtung County', 'Taitung County', 'Hualien County', 'Lienchiang County'
    ],

    // 區域
    districts: [
        // 台北市
        [
            ['Zhongzheng District', 'Datong District', 'Zhongshan District', 'Songshan District', 'Da’an District', 'Wanhua District', 'Xinyi District', 'Shilin District', 'Beitou District', 'Neihu District', 'Nangang District', 'Wenshan District'],

            ['100', '103', '104', '105', '106', '108', '110', '111', '112', '114', '115', '116']
        ],
        // 基隆市
        [
            ['Ren’ai District', 'Xinyi District', 'Zhongzheng District', 'Zhongshan District', 'Anle District', 'Nuannuan District', 'Qidu District'],

            ['200', '201', '202', '203', '204', '205', '206']
        ],
        // 新北市
        [
            ['Wanli District', 'Jinshan District', 'Banqiao District', 'Xizhi District', 'Shenkeng District', 'Shiding District', 'Ruifang District', 'Pingxi District', 'Shuangxi District', 'Gongliao District', 'Xindian District', 'Pinglin District', 'Wulai District', 'Yonghe District', 'Zhonghe District', 'Tucheng District', 'Sanxia District', 'Shulin District', 'Yingge District', 'Sanchong District', 'Xinzhuang District', 'Taishan District', 'Linkou District', 'LuzhouDistrict', 'Wugu District', 'Bali District', 'Tamsui District', 'Sanzhi District', 'Shimen District'],

            ['207', '208', '220', '221', '222', '223', '224', '226', '227', '228',
            '231', '232', '233', '234', '235', '236', '237', '238', '239', '241',
            '242', '243', '244', '247', '248', '249', '251', '252', '253']
        ],
        // 宜蘭縣
        [
            ['Yilan City', 'Toucheng Township', 'Jiaoxi Township', 'Zhuangwei Township', 'Yuanshan Township', 'Luodong Township', 'Sanxing Township', 'Datong Township', 'Wujie Township', 'Dongshan Township', 'Su’ao Township', 'Nan’ao Township', 'Diauyutai'],

            ['260', '261', '262', '263', '264', '265', '266', '267', '268', '269',
            '270', '272', '290']
        ],
        // 桃園市
    	[
    		['Zhongli District', 'Pingzhen District', 'Longtan District', 'Yangmei District', 'Xinwu District', 'Guanyin District', 'Taoyuan District', 'Guishan District', 'Bade District', 'Daxi District', 'Fuxing District', 'Dayuan District', 'Luzhu District'],

    		['320', '324', '325', '326', '327', '328', '330', '333', '334', '335',
    		'336', '337', '338']
        ],
        // 新竹市
        [
            ['East District', 'North District', 'Xiangshan District'],

            ['300', '300', '300']
        ],
        // 新竹縣
        [
            ['Zhubei City', 'Hukou Township', 'Xinfeng Township', 'Xinpu Township', 'Guanxi Township', 'Qionglin Township', 'Baoshan Township', 'Zhudong Township', 'Wufeng Township', 'Hengshan Township', 'Jianshi Township', 'Beipu Township', 'Emei Township'],

            ['302', '303', '304', '305', '306', '307', '308', '310', '311',
            '312', '313', '314', '315']
        ],
        // 苗栗縣
        [
            ['Zhunan Township', 'Toufen Township', 'Sanwan Township', 'Nanzhuang Township', 'Shitan Township', 'Houlong Township', 'Tongxiao Township', 'Yuanli Township', 'Miaoli City', 'Zaoqiao Township', 'Touwu Township', 'Gongguan Township', 'Dahu Township', 'Tai’an Township', 'Tongluo Township', 'Sanyi Township', 'Xihu Township', 'Zhuolan Township'],

            ['350', '351', '352', '353', '354', '356', '357', '358', '360', '361',
            '362', '363', '364', '365', '366', '367', '368', '369']
        ],
        // 台中市
        [
            ['Central District', 'East District', 'South District', 'West District', 'North District', 'Beitun District', 'Xitun District', 'Nantun District', 'Taiping District', 'Dali District', 'Wufeng District', 'Wuri District', 'Fengyuan District', 'Houli District', 'Shigang District', 'Dongshi District', 'Heping District', 'Xinshe District', 'Tanzi District', 'Daya District', 'Shengang District', 'Dadu District', 'ShaluDistrict', 'Longjing District', 'Wuqi District', 'Qingshui District', 'Dajia District', 'Waipu District', 'Da’an District'],

            ['400', '401', '402', '403', '404', '406', '407', '408', '411', '412',
            '413', '414', '420', '421', '422', '423', '424', '426', '427', '428',
            '429', '432', '433', '434', '435', '436', '437', '438', '439']
        ],
        // 彰化縣
        [
            ['Changhua City', 'Fenyuan Township', 'Huatan Township', 'Xiushui Township', 'Lukang Township', 'Fuxing Township', 'Xianxi Township', 'Hemei Township', 'Shengang Township', 'Yuanlin Township', 'Shetou Township', 'Yongjing Township', 'Puxin Township', 'Xihu Township', 'Dacun Township', 'Puyan Township', 'Tianzhong Township', 'Beidou Township', 'Tianwei Township', 'Pitou Township', 'Xizhou Township', 'Zhutang Township', 'Erlin Township', 'Dacheng Township', 'Fangyuan Township', 'Ershui Township'],

            ['500', '502', '503', '504', '505', '506', '507', '508', '509', '510',
            '511', '512', '513', '514', '515', '516', '520', '521', '522', '523',
            '524', '525', '526', '527', '528', '530']
        ],
        // 南投縣
        [
            ['Nantou City', 'Zhongliao Township', 'Caotun Township', 'Guoxing Township', 'Puli Township', 'Ren’ai Township', 'Mingjian Township', 'Jiji Township', 'Shuili Township', 'Yuchi Township', 'Xinyi Township', 'Zhushan Township', 'Lugu Township'],

            ['540', '541', '542', '544', '545', '546', '551', '552', '553', '555',
            '556', '557', '558']
        ],
        // 嘉義市
        [
            ['East District', 'West District'],

            ['600', '600']
        ],
        // 嘉義縣
        [
            ['FanluTownship', 'Meishan Township', 'Zhuqi Township', 'Alishan Township', 'Zhongpu Township', 'Dapu Township', 'Shuishang Township', 'Lucao Township', 'Taibao City', 'Puzi City', 'Dongshi Township', 'Liujiao Township', 'Xingang Township', 'Minxiong Township', 'Dalin Township', 'Xikou Township', 'Yizhu Township', 'Budai Township'],

            ['602', '603', '604', '605', '606', '607', '608', '611', '612',
            '613', '614', '615', '616', '621', '622', '623', '624', '625']
        ],
        // 雲林縣
        [
            ['Dounan Township', 'Dapi Township', 'Huwei Township', 'Tuku Township', 'Baozhong Township', 'Dongshi Township', 'Taixi Township', 'Lunbei Township', 'Mailiao Township', 'Douliu City', 'Linnei Township', 'Gukeng Township', 'Citong Township', 'Xiluo Township', 'Erlun Township', 'Beigang Township', 'Shuilin Township', 'Kouhu Township', 'Sihu Township', 'Yuanchang Township'],

            ['630', '631', '632', '633', '634', '635', '636', '637', '638', '640', '643',
            '646', '647', '648', '649', '651', '652', '653', '654', '655']
        ],
        // 台南市
        [
            ['West Central District', 'East District', 'South District', 'North District', 'Anping District', 'Annan District', 'Yongkang District', 'Guiren District', 'Xinhua District', 'Zuozhen District', 'Yujing District', 'Nanxi District', 'Nanhua District', 'Rende District', 'Guanmiao District', 'Longqi District', 'Guantian District', 'Madou District', 'Jiali District', 'Xigang District', 'Qigu District', 'Jiangjun District', 'Xuejia District', 'Beimen District', 'Xinying District', 'Houbi District', 'Baihe District', 'Dongshan District', 'Liujia District', 'Xiaying District', 'Liuying District', 'Yanshui District', 'Shanhua District', 'Danei District', 'Shanshang District', 'Xinshi District', 'Anding District'],

            ['700', '701', '702', '704', '708', '709', '710', '711', '712', '713', '714',
            '715', '716', '717', '718', '719', '720', '721', '722', '723', '724', '725',
            '726', '727', '730', '731', '732', '733', '734', '735', '736', '737', '741',
            '742', '743', '744', '745']
        ],
        // 高雄市
        [
            ['Xinxing District', 'Qianjin District', 'Lingya District', 'Yancheng District', 'Gushan District', 'Qijin District', 'Qianzhen District', 'Sanmin District', 'Nanzi District', 'Xiaogang District', 'Zuoying District', 'Renwu District', 'Dashe District', 'Dongsha Islands', 'Nansha Islands', 'Gangshan District', 'Luzhu District', 'Alian District', 'Tianliao District', 'Yanchao District', 'Qiaotou District', 'Ziguan District', 'Mituo District', 'Yong’an District', 'Hunei District', 'Fengshan District', 'Daliao District', 'Linyuan District', 'Niaosong District', 'Dashu District', 'Qishan District', 'Meinong District', 'Liugui District', 'Neimen District', 'Shanlin District', 'Jiaxian District', 'Taoyuan District', 'Namaxia District', 'Maolin District', 'Qieding District'],

            ['800', '801', '802', '803', '804', '805', '806', '807', '811', '812', '813',
            '814', '815', '817', '819', '820', '821', '822', '823', '824', '825', '826', '827', '828',
            '829', '830', '831', '832', '833', '840', '842', '843', '844', '845', '846',
            '847', '848', '849', '851', '852']
        ],
        // 澎湖縣
        [
            ['Magong City', 'Xiyu Township', 'Wang’an Township', 'Qimei Township', 'Baisha Township', 'Huxi Township'],

            ['880', '881', '882', '883', '884', '885']
        ],
        // 金門縣
        [
            ['Jinsha Township', 'Jinhu Township', 'Jinning Township', 'Jincheng Township', 'Lieyu Township', 'Wuqiu Township'],

            ['890', '891', '892', '893', '894', '896']
        ],
        // 屏東縣
        [
            ['Pingtung City', 'Sandimen Township', 'Wutai Township', 'Majia Township', 'Jiuru Township', 'Ligang Township', 'Gaoshu Township', 'Yanpu Township', 'Changzhi Township', 'Linluo Township', 'Zhutian Township', 'Neipu Township', 'Wandan Township', 'Chaozhou Township', 'Taiwu Township', 'Laiyi Township', 'Wanluan Township', 'Kanding Township', 'Xinpi Township', 'Nanzhou Township', 'Linbian Township', 'Donggang Township', 'Liuqiu Township', 'Jiadong Township', 'Xinyuan Township', 'Fangliao Township', 'Fangshan Township', 'Chunri Township', 'Shizi Township', 'Checheng Township', 'Mudan Township', 'Hengchun Township', 'Manzhou Township'],

            ['900', '901', '902', '903', '904', '905', '906', '907', '908', '909', '911',
            '912', '913', '920', '921', '922', '923', '924', '925', '926', '927', '928',
            '929', '931', '932', '940', '941', '942', '943', '944', '945', '946', '947']
        ],
        // 台東縣
        [
            ['Taitung City', 'Ludao Township', 'Lanyu Township', 'Yanping Township', 'Beinan Township', 'Luye Township', 'Guanshan Township', 'Haiduan Township', 'Chishang Township', 'Donghe Township', 'Chenggong Township', 'Changbin Township', 'Taimali Township', 'Jinfeng Township', 'Dawu Township', 'Daren Township'],

            ['950', '951', '952', '953', '954', '955', '956', '957', '958', '959', '961',
            '962', '963', '964', '965', '966']
        ],
        // 花蓮縣
        [
            ['Hualien City', 'Xincheng Township', 'Xiulin Township', 'Ji’an Township', 'Shoufeng Township', 'Fenglin Township', 'Guangfu Township', 'Fengbin Township', 'Ruisui Township', 'Wanrong Township', 'Yuli Township', 'Zhuoxi Township', 'Fuli Township'],

            ['970', '971', '972', '973', '974', '975', '976', '977', '978', '979', '981',
            '982', '983']
        ],
        // 連江縣
        [
            ['Nangan Township', 'Beigan Township', 'Juguang Township', 'Dongyin Township'],

            ['209', '210', '211', '212']
        ]
    ]
};
